import { Component } from '@angular/core';
import { AnnounceBarComponent } from './announce-bar.component';
import { HeaderComponent } from './header.component';
import { FooterComponent } from './footer.component';

@Component({
  selector: 'hx-page-shell',
  standalone: true,
  imports: [AnnounceBarComponent, HeaderComponent, FooterComponent],
  template: `
    <hx-announce-bar></hx-announce-bar>
    <hx-header></hx-header>
    <main id="main-content">
      <ng-content></ng-content>
    </main>
    <hx-footer></hx-footer>
  `,
})
export class PageShellComponent {}
